<template>
  <div>
    <div class="md-modal modal-msg md-modal-transition editmodal" v-bind:class="{'md-show':c_edit}">
      <div class="md-modal-inner">
        <div class="md-top">
          <button class="md-close" @click='closeModal'>Close</button>
        </div>
        <div class="md-content">
          <div class="confirm-tips">
            <slot name="msg"></slot>
          </div>
          <div class="form">
            <el-form ref="form" :model="c_Obj" label-width="100px">
              <el-form-item label="省市区">
                <div class="linkage">
                  <el-select
                    class="region_input"
                    v-model="c_Obj.provinceName"
                    @change="choseProvince"
                    placeholder="省级地区">
                    <el-option
                      v-for="item in province"
                      :key="item.id"
                      :label="item.value"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select
                    class="region_input"
                    v-model="c_Obj.cityName"
                    @change="choseCity"
                    placeholder="市级地区">
                    <el-option
                      v-for="item in shi1"
                      :key="item.id"
                      :label="item.value"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select
                    class="region_input"
                    v-model="c_Obj.countyName"
                    @change="choseBlock"
                    placeholder="区级地区">
                    <el-option
                      v-for="item in qu1"
                      :key="item.id"
                      :label="item.value"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="详细地址">
                <el-input v-model="c_Obj.detailInfo" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">确定</el-button>
                <!-- <el-button @click='closeModal'>取消</el-button> -->
                <el-button @click='stop'>取消</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="btn-wrap">
            <slot name="btnGroup"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class='md-overlay' v-if="c_edit" @click='closeModal'></div>
  </div>

</template>

<script>
  import axios from "axios"
  import "@/assets/css/index.css"
  import {getCookie,removeHTMLTag,isValidPhone,isValidName} from "../util/util";

  export default {
    props: ["c_edit","c_Obj"],
    inject:['reload'],
    data() {
      return {
        mapJson: '../static/json/map.json',
        // mapJson: 'https://uat.liferiverai.cn/jyw-web/static/json/map.json',
        province: '',
        sheng: '',
        shi: '',
        shi1: [],
        qu: '',
        qu1: [],
        city: '',
        block: '',
      };
    },
    //  computed: {
    //   c_Obj() {
    //     return this.$store.state.c_Obj;
    //   },
    // },
    created: function () {
      this.$emit("c_Obj")
    },
    mounted(){
      this.getCityData()
      let obj = this.c_Obj
    },
    methods: {
      init: function(obj){
        this.choseProvince(obj.provinceName)
        this.choseCity(obj.cityName)
      },
      // 加载china地点数据，三级
      getCityData: function () {
        var that = this
        axios.defaults.baseURL = ''
        axios.get(this.mapJson).then(function (response) {
          axios.defaults.baseURL = process.env.API_ROOT
          if (response.status == 200) {
            var data = response.data
            // console.log(data)
            that.province = []
            that.city = []
            that.block = []
            // 省市区数据分类
            for (var item in data) {
              if (item.match(/0000$/)) {//省
                that.province.push({id: item, value: data[item], children: []})
              } else if (item.match(/00$/)) {//市
                that.city.push({id: item, value: data[item], children: []})
              } else {//区
                that.block.push({id: item, value: data[item]})
              }
            }
            // 分类市级
            for (var index in that.province) {
              for (var index1 in that.city) {
                if (that.province[index].id.slice(0, 2) === that.city[index1].id.slice(0, 2)) {
                  that.province[index].children.push(that.city[index1])
                }
              }
            }
            // 分类区级
            for (var item1 in that.city) {
              for (var item2 in that.block) {
                if (that.block[item2].id.slice(0, 4) === that.city[item1].id.slice(0, 4)) {
                  that.city[item1].children.push(that.block[item2])
                }
              }
            }
          }
          else {
            console.log(response.status)
          }
        }).catch(function (error) {
          console.log(typeof+error)
        })
      },
      // 选省
      choseProvince: function (e) {
        console.log(e)
        // console.log(this.province);
        for (var index2 in this.province) {
          if (e === this.province[index2].value) {
            this.sheng = this.province[index2].value
            this.c_Obj.provinceName = this.sheng
            this.c_Obj.cityName = ""
            this.c_Obj.countyName = ""

            this.shi1 = this.province[index2].children
            this.shi = this.province[index2].children[0].value
            this.qu1 = this.province[index2].children[0].children
            this.qu = this.province[index2].children[0].children[0].value
            this.E = this.qu1[0].id
          }
        }
        console.log(this.sheng)
      },
      // 选市
      choseCity: function (e) {
        console.log(this.city);
        for (var index3 in this.city) {
          if (e === this.city[index3].value) {
            this.shi = this.city[index3].value
            this.c_Obj.cityName = this.shi
            this.c_Obj.countyName = ""
            this.qu1 = this.city[index3].children
            // this.qu = this.city[index3].children[0].value
            this.E = this.qu1[0].id
            console.log(this.shi)
          }
        }
      },
      // 选区
      choseBlock: function (e) {
        this.E = e;
        for (var index3 in this.block) {
          if (e === this.block[index3].value) {
            this.qu = this.block[index3].value
            this.c_Obj.countyName = this.qu
          }
        }
      },
      closeModal() {
        this.$emit('c_close')
      },
      onSubmit() {
        this.editAddress()
      },
      //  编辑地址
      editAddress() {
          this.closeModal()
            this.$message({
              type: 'success',
              message: '编辑成功!'
            });
      },
      stop() {
        this.reload()
        this.closeModal()
      }
    }
  }
</script>
<style>
  /*.form{*/
  /*width: 100%;*/
  /*heigth:200px;*/
  /*}*/
  .el-switch.is-checked .el-switch__core {
    border-color: #00C5B0;
    background-color: #00C5B0;
  }

  .el-button--default:focus, .el-button--default:hover {
    border-color: #00C5B0;
    color: #00C5B0;
    background-color: #fff;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #00C5B0;
    border-color: #00C5B0;
    color: #ffffff;
  }

  .region_input {
    margin-bottom: 20px;
  }


</style>




// WEBPACK FOOTER //
// src/components/AddEdit.vue